export function ProcessSection({ isDark }) {
  const steps = [
    { step: "01", title: "Discover", desc: "AI scans global markets for arbitrage opportunities" },
    { step: "02", title: "Analyze", desc: "Deep analysis with probability scores and fundamentals" },
    { step: "03", title: "Invest", desc: "Execute with live links to brokers and exchanges" },
    { step: "04", title: "Grow", desc: "Track your portfolio and compound returns" }
  ];

  return (
    <section className={`py-20 px-4 sm:px-6 lg:px-8 border-t ${isDark ? 'border-white/5' : 'border-gray-100'}`}>
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <p className="text-purple-500 text-sm font-semibold tracking-widest uppercase mb-4">How It Works</p>
          <h2 className={`text-3xl sm:text-4xl font-bold ${isDark ? 'text-white' : 'text-gray-900'}`}>
            Discover &#8226; Analyze &#8226; Invest &#8226; Grow
          </h2>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {steps.map((item) => (
            <div key={item.step} className="relative group">
              <div className="absolute -inset-px bg-gradient-to-r from-purple-600/50 to-transparent rounded-xl opacity-0 group-hover:opacity-100 transition-opacity blur" />
              <div className={`relative rounded-xl p-6 border transition-colors ${isDark ? 'bg-[#12121a] border-white/5 hover:border-purple-500/30' : 'bg-gray-50 border-gray-200 hover:border-purple-300'}`}>
                <span className={`text-4xl font-bold ${isDark ? 'text-purple-600/30' : 'text-purple-200'}`}>{item.step}</span>
                <h3 className={`text-xl font-bold mt-4 mb-2 ${isDark ? 'text-white' : 'text-gray-900'}`}>{item.title}</h3>
                <p className={`text-sm ${isDark ? 'text-gray-400' : 'text-gray-600'}`}>{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
